<template>
  <div class="registeredUsers">
    <div class="result_info_area">
      <img alt="" class="search_result" :src="searchResult" />
      <div class="result_info_item result_info_item1">
        <label>
          <img alt="" :src="icon1" />
          <span class="lable_title">姓名</span>
        </label>
        <span class="customerName">
          {{ customerName.part1 }}
          <input class="authenticate" type="text" placeholder="请输入" v-model="inputNamePart" />
          {{ customerName.part2 }}
        </span>
      </div>
      <div class="result_info_item">
        <label>
          <img alt="" :src="icon2" />
          <span class="lable_title">身份证号</span>
        </label>
        <span>{{ identifyNum }}</span>
      </div>
    </div>
    <button class="determine" @click="determine">确定</button>
    <button class="again" @click="next">以上信息不是我的，重新认证</button>
    <Loading :switchs="switchs" />
  </div>
</template>
<script>
import api from '@/api/api.js'
import Loading from '@/components/Loadings/Loading'
import { motorCodeObj } from '@/utils/const'
// import checkFormat from "@/utils/checkFormat.js";
export default {
  name: 'RegisteredUsers',
  data() {
    return {
      customerName: {
        part1: '',
        part2: ''
      },
      inputNamePart: '',
      queryCustomerName: '',
      phoneNum: '',
      identifyNum: '',
      identityNumberNormal: '', // 注册使用
      personalName: '', // 注册使用
      userType: '',
      switchs: false,
      searchResult: api.imgAllUrl + '/customer Certification.png',
      icon1: api.imgAllUrl + '/registerName.png',
      icon2: api.imgAllUrl + '/registerIdentifyNum.png',
      comName: '', // 机构名
    }
  },
  components: {
    Loading: Loading
  },
  activated() {
    this.$store.commit('set_showStep', false)
  },
  created() {
    document.title = '紫金保险'
    this.phoneNum = this.$route.query.pNum
    let obj = {
      identityNumber: "",
      token: localStorage.getItem('setToken')
    }
    this.switchs = true
    this.$http
      .post(api.newFindOfficialUserInfo, obj)
      .then((res) => {
        console.log(res, '--000999')
        this.switchs = false
        if (res.data.rtnCode === '0000') {
          // 用户信息是否存在于保单中(0: 存在; 1: 不存在)
          if (res.data.customerInfoExist === '0') {
            this.identifyNum = res.data.identityNumber
            this.identityNumberNormal = res.data.identityNumberNormal
            this.personalName = res.data.name
            const name = res.data.name
            // let name = "欧阳福多";
            if (name.length === 1) {
              this.inputNamePart = ''
              this.queryCustomerName = name
            } else if (name.length === 2) {
              this.customerName.part1 = name.substr(0, 1)
              this.queryCustomerName = name.substr(1)
            } else if (name.length > 2) {
              this.customerName.part1 = name.substr(0, 1)
              this.customerName.part2 = name.substr(name.length - 1)
              this.queryCustomerName = name.substring(1, name.length - 1)
            }
          } else {
            this.$toast({
              message: '未查询到您的信息，请确认后再重试',
              position: 'top',
              duration: 1500
            });
          }
        } else {
          this.$toast({
            message: `${res.data.rtnMsg}，请退出重试`,
            position: 'top',
            duration: 1500
          })
        }
      })
      .catch((error) => {
        this.switchs = false
        console.log(error)
        this.$toast({
          message: error,
          position: 'top'
        })
      })
  },
  mounted() {
    const comName = localStorage.getItem('setMotorAreaName')
    this.comName = comName
    localStorage.setItem('setMotorCode', `${this.comName}Code`)
  },
  methods: {
    determine() {
      let sex = parseInt(this.identifyNum.substr(16, 1)) % 2 == 1 ? "男" : "女"
      let userPersonalName = this.customerName.part1 + this.inputNamePart + this.customerName.part2 + ''
      let params = {
        identifyNumber: '',
        userName: userPersonalName,
        code: '',
        token: localStorage.getItem('setToken')
      };
      this.switchs = true
      this.$http
      .post(api.newRegisterForOfficial, params)
      .then(res=>{
        console.log(res.data, "res.data-=-=-=-=-=-=-=-=-=-=-");
        if (res.data.rtnCode === "0000") {
            this.switchs = false
            localStorage.setItem('setToken', res.data.token)
            this.userType = res.data.userType;
            var obj1 = {
              identifyNum: res.data.identifyCode,
              name: res.data.userName,
              phoneNumber: this.phoneNum,
              gender: sex
            };
            localStorage.setItem('cInfo', JSON.stringify(obj1))
            // this.$router.push({ name: 'BaseInfo' })
        } else if (res.data.rtnCode === "9940") {
          this.switchs = false
          this.$toast({
            message: "您输入的信息有误，请重新输入",
            position: "top",
            duration: 1400,
          });
        } else {
          this.switchs = false
          if (res.data.rtnMsg === '该用户尚未登录过') {
            window.location.href = process.env.API_HOST + motorCodeObj[localStorage.getItem('setMotorCode')]
            return false
          }
          this.$toast({
            message: res.data.rtnMsg,
            position: "top",
          });
          return false;
        }
      })
      .then((token) => {
          this.switchs = true;
          this.$http.get(api.motorPolicy+`/${this.comName}`).then(resTwo=>{
            this.switchs = false;
            console.log(resTwo, 'motorPolicy')
            if (resTwo.data.rtnCode==='0000') {
              if (resTwo.data.data==null||resTwo.data.data.policyNo==null||resTwo.data.data.policyNo==undefined||resTwo.data.data.policyNo=='') {
                this.$router.push({name:'BaseInfo'})
              } else {
                this.$router.push({name:'InsuredSuccess',query:{
                  licenseNo:resTwo.data.data.liceseNo,
                  policyNo:resTwo.data.data.policyNo,
                  areaName:this.comName
                }})
              }
            } else {
              Toast(resTwo.data.rtnMsg)
            }
          })
        })
      .catch(err=>{
        this.switchs = false
        this.$toast({
          message: err,
          position: 'top'
        })
      })
    },
    getQueryVariable(variable) {
      var query = window.location.search.substring(1)
      var vars = query.split('&')
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=')
        if (pair[0] === variable) {
          return pair[1]
        }
      }
      return false
    },
    next() {
      this.$router.push({
        name: 'PerfectPersonalInfo',
        query: {
          pNum: this.phoneNum,
          captchaId: this.$route.query.captchaId, // 验证码ID
          captchaVal: this.$route.query.captchaVal // 验证码
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import "./registeredUsers.scss";
</style>




// WEBPACK FOOTER //
// src/pages/motor/components/motorLogin/components/registeredUsers/registeredUsers.vue